// extracted by mini-css-extract-plugin
module.exports = {"phaseColorItem":"phase-color-selector-element_phaseColorItem__3DUtN","selected":"phase-color-selector-element_selected__3l8qo"};